import React from "react";
import { Row, Col, Statistic } from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { ValidationSummary } from "../../types/validator";

/**
 * The 5-stat validation summary row (Total Networks / Adapters Found /
 * Adapters Missing / SDK Issues / Constraint Violations). Shared between the
 * ValidationResult breakdown rendered in ValidatorDrawer and the inline
 * summary shown on the SDK view as soon as auto-validation completes.
 */
export const ValidationStats: React.FC<{ summary: ValidationSummary }> = ({
  summary,
}) => {
  return (
    <Row gutter={16}>
      <Col span={4}>
        <Statistic
          title="Total Networks"
          value={summary.totalNetworks}
          valueStyle={{ color: "#1890ff" }}
        />
      </Col>
      <Col span={5}>
        <Statistic
          title="Adapters Found"
          value={summary.adaptersFound}
          valueStyle={{ color: "#52c41a" }}
          prefix={<CheckCircleOutlined />}
        />
      </Col>
      <Col span={5}>
        <Statistic
          title="Adapters Missing"
          value={summary.adaptersMissing}
          valueStyle={{
            color: summary.adaptersMissing > 0 ? "#faad14" : "#52c41a",
          }}
          prefix={
            summary.adaptersMissing > 0 ? (
              <ExclamationCircleOutlined />
            ) : (
              <CheckCircleOutlined />
            )
          }
        />
      </Col>
      <Col span={5}>
        <Statistic
          title="SDK Issues"
          value={summary.sdkIssues}
          valueStyle={{
            color: summary.sdkIssues > 0 ? "#ff4d4f" : "#52c41a",
          }}
          prefix={
            summary.sdkIssues > 0 ? (
              <CloseCircleOutlined />
            ) : (
              <CheckCircleOutlined />
            )
          }
        />
      </Col>
      <Col span={5}>
        <Statistic
          title="Constraint Violations"
          value={summary.constraintViolations}
          valueStyle={{
            color: summary.constraintViolations > 0 ? "#ff4d4f" : "#52c41a",
          }}
          prefix={
            summary.constraintViolations > 0 ? (
              <CloseCircleOutlined />
            ) : (
              <CheckCircleOutlined />
            )
          }
        />
      </Col>
    </Row>
  );
};
